import React from 'react'
    import { 
      Building2, 
      Home, 
      Rocket, 
      CreditCard, 
      TrendingUp, 
      Shield,
      Users,
      FileText,
      DollarSign,
      Settings
    } from 'lucide-react'

    const ServicesSection = () => {
      const services = [
        {
          icon: Building2,
          title: "Business Loan Brokerage",
          description: "Connect with private lenders and alternative financing options when traditional banks say no.",
          audience: "Small businesses, startups, entrepreneurs",
          unique: "Access to subprime and alternative lenders"
        },
        {
          icon: Home,
          title: "Hard Money & Fix-and-Hold Loans",
          description: "Fast real estate financing for investors and property developers with flexible terms.",
          audience: "Real estate investors, property flippers",
          unique: "48-72 hour approvals with asset-based lending"
        },
        {
          icon: Rocket,
          title: "Startup Funding Packages",
          description: "Comprehensive funding solutions for new businesses including equipment and working capital.",
          audience: "New entrepreneurs, startup founders",
          unique: "No revenue history required programs"
        },
        {
          icon: CreditCard,
          title: "Business Credit Building",
          description: "Strategic credit establishment and repair to improve future funding opportunities.",
          audience: "Business owners with poor/no credit",
          unique: "Proprietary credit optimization strategies"
        },
        {
          icon: TrendingUp,
          title: "Real Estate Investor Funding",
          description: "DSCR loans, fix-and-flip financing, and rental property acquisition funding.",
          audience: "Property investors, real estate professionals",
          unique: "No personal income verification required"
        },
        {
          icon: Shield,
          title: "C-Corp & LLC Funding Strategy",
          description: "Entity-specific funding approaches leveraging corporate structure advantages.",
          audience: "Incorporated businesses, LLCs",
          unique: "Corporate credit line establishment"
        },
        {
          icon: Users,
          title: "COI-Based Lending Support",
          description: "Certificate of Insurance leverage for improved approval rates and terms.",
          audience: "Contractors, service businesses",
          unique: "Insurance-backed funding strategies"
        },
        {
          icon: FileText,
          title: "Corporate Leasing Qualification",
          description: "Equipment and vehicle leasing programs with flexible qualification criteria.",
          audience: "Growing businesses needing equipment",
          unique: "Alternative qualification methods"
        },
        {
          icon: DollarSign,
          title: "DSCR/No-Income Loans",
          description: "Debt Service Coverage Ratio loans based on property cash flow, not personal income.",
          audience: "Real estate investors, property owners",
          unique: "Cash flow based approvals only"
        },
        {
          icon: Settings,
          title: "Capital Consulting & Compliance Setup",
          description: "Strategic capital planning and regulatory compliance for sustainable growth.",
          audience: "Established businesses, nonprofits",
          unique: "Comprehensive compliance and growth planning"
        }
      ]

      return (
        <section id="services" className="py-20 bg-white" data-component-path="client/src/components/ServicesSection.jsx" data-component-line="1:4" data-component-id="client/src/components/ServicesSection.jsx:1:4">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/components/ServicesSection.jsx" data-component-line="2:6" data-component-id="client/src/components/ServicesSection.jsx:2:6">
            <div className="text-center mb-16" data-component-path="client/src/components/ServicesSection.jsx" data-component-line="3:8" data-component-id="client/src/components/ServicesSection.jsx:3:8">
              <h2 className="text-3xl md:text-4xl font-bold text-black mb-6" data-component-path="client/src/components/ServicesSection.jsx" data-component-line="4:10" data-component-id="client/src/components/ServicesSection.jsx:4:10">
                Our Funding Services
              </h2>
              <p className="text-lg text-gray-700 max-w-3xl mx-auto" data-component-path="client/src/components/ServicesSection.jsx" data-component-line="5:10" data-component-id="client/src/components/ServicesSection.jsx:5:10">
                Comprehensive funding solutions tailored to your business needs and credit situation
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-component-path="client/src/components/ServicesSection.jsx" data-component-line="6:8" data-component-id="client/src/components/ServicesSection.jsx:6:8">
              {services.map((service, index) => {
                const IconComponent = service.icon
                return (
                  <div key={index} className="service-card bg-white p-6 rounded-lg shadow-lg border border-gray-100 hover:border-gold transition-all" data-component-path="client/src/components/ServicesSection.jsx" data-component-line="7:14" data-component-id="client/src/components/ServicesSection.jsx:7:14">
                    <div className="w-12 h-12 bg-gold rounded-lg flex items-center justify-center mb-4" data-component-path="client/src/components/ServicesSection.jsx" data-component-line="8:16" data-component-id="client/src/components/ServicesSection.jsx:8:16">
                      <IconComponent className="text-white" size={24} />
                    </div>
                    <h3 className="text-xl font-semibold text-black mb-3" data-component-path="client/src/components/ServicesSection.jsx" data-component-line="9:16" data-component-id="client/src/components/ServicesSection.jsx:9:16">{service.title}</h3>
                    <p className="text-gray-600 mb-4" data-component-path="client/src/components/ServicesSection.jsx" data-component-line="10:16" data-component-id="client/src/components/ServicesSection.jsx:10:16">{service.description}</p>
                    <div className="space-y-2" data-component-path="client/src/components/ServicesSection.jsx" data-component-line="11:16" data-component-id="client/src/components/ServicesSection.jsx:11:16">
                      <div data-component-path="client/src/components/ServicesSection.jsx" data-component-line="12:18" data-component-id="client/src/components/ServicesSection.jsx:12:18">
                        <span className="text-sm font-medium text-gold" data-component-path="client/src/components/ServicesSection.jsx" data-component-line="13:20" data-component-id="client/src/components/ServicesSection.jsx:13:20">Who it helps:</span>
                        <p className="text-sm text-gray-500" data-component-path="client/src/components/ServicesSection.jsx" data-component-line="14:20" data-component-id="client/src/components/ServicesSection.jsx:14:20">{service.audience}</p>
                      </div>
                      <div data-component-path="client/src/components/ServicesSection.jsx" data-component-line="15:18" data-component-id="client/src/components/ServicesSection.jsx:15:18">
                        <span className="text-sm font-medium text-gold" data-component-path="client/src/components/ServicesSection.jsx" data-component-line="16:20" data-component-id="client/src/components/ServicesSection.jsx:16:20">Our advantage:</span>
                        <p className="text-sm text-gray-500" data-component-path="client/src/components/ServicesSection.jsx" data-component-line="17:20" data-component-id="client/src/components/ServicesSection.jsx:17:20">{service.unique}</p>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </section>
      )
    }

    export default ServicesSection